module.exports = __webpack_public_path__ + "img/madlena-tsvetkova-p.b2d35592.webp";